import { useState } from "react";
import { formatTime } from "../../Util/helpers";
import "./style.css";

const SeekBar = ({ currentTime, duration, onSeek }) => {
    const [seeking, setSeeking] = useState(false);
    const [tempTime, setTempTime] = useState(currentTime);

    const handleRelease = (val) => {
        let time = Math.min(val, duration); // clamp to duration
        setSeeking(false);
        onSeek(time);
    };

    return (
        <div className="seek-bar">
            <input
                type="range"
                min={0}
                max={duration}
                value={seeking ? tempTime : currentTime}
                step="0.1" // smoother seek
                onMouseDown={() => setSeeking(true)}
                onTouchStart={() => setSeeking(true)}
                onChange={(e) => setTempTime(parseFloat(e.target.value))}
                onMouseUp={(e) => handleRelease(parseFloat(e.target.value))}
                onTouchEnd={() => handleRelease(tempTime)}
                style={{ width: "100%" }}
            />
            <div className="d-flex justify-content-between mt-3">
                <h5>{formatTime(seeking ? tempTime : currentTime)}</h5>
                <h5>{formatTime(duration)}</h5>
            </div>
        </div>
    );
};

export default SeekBar;
